import { AddMediaValidationService } from './AddMediaValidationService';
import { UnfurlScrapeCache } from './UnfurlScrapeCache';

/**
 * The app-wide unfurl scrape cache.
 *
 * Split out from `UnfurlScrapeCache` purely so the cache class itself stays importable by the
 * standalone `npx tsx` test runner: this module reaches `AddMediaValidationService`, which
 * transitively pulls in React components and SCSS modules that the runner cannot parse.
 *
 * Module scope is deliberate — see the `UnfurlScrapeCache` docstring for why this must not be
 * a MobX context provider.
 */
const validationService = new AddMediaValidationService();

export const unfurlCache = new UnfurlScrapeCache((url, onProgress) =>
  // No AbortSignal: a scrape intentionally has no canceller, so that closing the modal (or
  // briefly mistyping the URL) can't destroy in-flight work.
  validationService.url.validateURLContent(url, undefined, onProgress),
);
